<div *ngIf="data$ | async as data" class="flex flex-col flex-grow md:mx-10">
  <div class="mx-5 flex flex-col lg:flex-grow lg:flex-row">
    <div class="lg:pr-16 lg:w-5/12 mt-5 lg:mt-10">
      <div class="hidden lg:inline-block mb-8">
        <ng-container *ngTemplateOutlet="returnBtn"></ng-container>
      </div>

      <div>
        <h1 class="font-bold text-gray-900 text-lg md:text-2xl">
          Karta płatnicza
        </h1>

        <p class="mt-3 lg:mt-6 leading-tighter md:text-sm text-gray-900">
          Kliknięcie w przycisk "Zapłać" spowoduje opłacenie bieżącej faktury niezwłocznie.
        </p>

        <div class="value-prop">
          <p class="title">Zapisz dane karty do kolejnych płatności</p>
          <p class="description">
            Dokończ płatność w PayAppce i zyskaj <strong class="font-semibold">zapamiętanie karty</strong>, automatyczne
            i odroczone płatności i więcej!
          </p>
          <div class="flex flex-col mt-4">
            <button class="w-full flex-col items-center" color="primary" mat-flat-button>
              <span class="text-sm tracking-tight">Kontynuuj w PayAppce</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col lg:flex-grow lg:bg-gray-300 lg:px-8 xl:px-12 items-center">
      <div
        id="imoje-widget__wrapper"
        class="mt-5 lg:mb-8 xl:mb-12 lg:mt-10 rounded-lg border border-gray-200 light-shadow bg-white flex lt-sm:-mx-5"
      ></div>
    </div>
  </div>

  <div class="flex flex-col lg:hidden mx-5 mt-3 mb-5">
    <ng-container *ngTemplateOutlet="returnBtn"></ng-container>
  </div>
</div>

<ng-template #returnBtn>
  <button
    (click)="startPaymentAgain()"
    class="flex-grow rounded-lg border border-gray-200 hover:bg-gray-100"
    mat-ripple
  >
    <span class="flex flex-row items-center text-gray-600 py-1">
      <mat-icon>chevron_left</mat-icon>
      <span class="flex-grow text-sm pl-3 pr-6">Wróć do wyboru metody płatności</span>
    </span>
  </button>
</ng-template>
